(ns frontend.actions.onboarding
  (:require [frontend.conn :as conn]
            [promesa.core :as p]))

(defn *->initialize-account [data on-success! on-error!]
  (-> (conn/sendp! :onboarding/initialize-account
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

